import {Col, Form, Row} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {connect} from '../Notes/wrapper'
import {FormCheck, FormLabel} from '../Utilities/Form'
import {useInputDataState, useLabels} from '../../functions'
import {writeToRedis} from '../../state/customerAsyncActions'

export const ConsentToContact = () => {
    const labels = useLabels()
    const dispatch = useDispatch()
    const [contactConsent, setContactConsent] = useInputDataState('contactConsent')

    const onChangeContactConsent = async (event) => {
        setContactConsent(event)
        await dispatch(writeToRedis())
    }

    return <Row className="mt-3 mb-3">
        <Col>
            <Form.Group>
                <FormLabel bold={true}>{labels.consentToContact}</FormLabel>

                <FormCheck
                    label={labels.yesOption}
                    type="radio"
                    value="Y"
                    onChange={onChangeContactConsent}
                    checked={contactConsent === 'Y'}
                />

                <FormCheck
                    label="No"
                    type="radio"
                    value="N"
                    onChange={onChangeContactConsent}
                    checked={contactConsent === 'N'}
                />
            </Form.Group>
        </Col>
    </Row>
}

export default connect(ConsentToContact, 'consent-to-contact')